import {
    Crown,
    Zap,
    Headset,
    Wrench,
    Building, ThumbsUp, Award, CheckCircle
} from 'lucide-react';
import ChimneymainImg from '../img/hob-about-img-main.png';
import CTA from './Cta';
import HomeAboutUs from './Home/HomeAboutUs';
import CountUpCards from './CountUpCards';
import HomeServices from './Home/HomeServices';
import BestServices from './Home/BestService';

function Speciality() {
    return (
        <>
            <section className="hob-about-hero">
                <div className="hob-about-hero-content">
                    <h1 className="hob-about-title">
                        Our Specialities
                    </h1>
                    <p className="hob-about-subtitle">
                        Expert care across diverse areas of mental and emotional well-being.
                    </p>
                </div>
            </section>



            <BestServices />

            <CTA />
        </>
    );
}

export default Speciality;
